new Vue({
  delimiters: ['[[', ']]'],
  el: '#footer',
  data: {},
});

$(document).ready(function () {
  document.querySelectorAll('a.whatsapp[href*="api.whatsapp.com"], a.no-svg-whatsapp[href*="api.whatsapp.com"]').forEach(function (element) {
    const href = element.getAttribute('href');
    element.setAttribute('href', href.replace(/phone=([^&]+)/, function (match, phone) {
      return 'phone=' + decodeURIComponent(phone).replace(/\D/g, '');
    }));
  });
});
